import { useAuth0 } from "@auth0/auth0-react";
import { useUser } from "@/context/UserContext";
import { isEmpty } from "lodash";

/**
 * Hook to check if user has admin or editor access privileges
 * @returns Object containing admin access status and auth loading state
 */
export const useAdminAccess = () => {
    const { isAuthenticated, isLoading } = useAuth0();
    const { userState } = useUser();

    const hasAdminAccess =
        isAuthenticated && !isEmpty(userState?.type) && (userState.type === "admin" || userState.type === "editor");

    return { hasAdminAccess, isLoading };
};
